import { ReactComponent as GoogleLoginIcon } from '@common/icons/GoogleLogin.svg';
import classnames from 'classnames';
import React from 'react';

import { COOKIE_KEYS, getGoogleLoginUrl, getGoogleRegisterUrl } from '../../utils/constants';
import history from '../../utils/history';
import { setLocalStorageItem } from '../../utils/token';

interface CustomGoogleLoginProps {
  isRegister?: boolean;
  isModal?: boolean;
}

const CustomGoogleLogin: React.FC<CustomGoogleLoginProps> = ({ isRegister, isModal }) => {
  const searchParams = new URLSearchParams(history.location.search);
  const redirectUrl = searchParams.get('redirect_url');
  return (
    <span
      onClick={() => {
        setLocalStorageItem(COOKIE_KEYS.AFTER_LOGIN_REDIRECT, redirectUrl || '');
        const toRedirectUrl = window.location.href.split('?')[0];
        window.location.href = isRegister ? getGoogleRegisterUrl(toRedirectUrl) : getGoogleLoginUrl(toRedirectUrl);
      }}
      className={classnames(
        'cursor-pointer flex items-center text-14 font-medium bg-white p-8 w-full disabled:text-disabled',
        {
          'h-40 rounded-md shadow-md': !isModal,
          'h-46 rounded-sm shadow-authGoogle': isModal,
        },
      )}
    >
      <div>
        <GoogleLoginIcon />
      </div>
      <div className="flex-1 text-center">Continue with Google</div>
    </span>
  );
};

export default CustomGoogleLogin;
